import request from '../../utils/request';

export function getOrders(params) {
  return request(`/orders`, {
    method: 'GET',
    params,
  });
}

export function getOrder(params) {
  const { id } = params;
  return request(`/orders/${id}`, {
    method: 'GET',
  });
}

export function getOrderByDBId(params) {
  const { id } = params;
  return request(`/orders/id/${id}`, {
    method: 'GET',
  });
}

export function createOrder(params) {
  return request(`/orders`, {
    method: 'POST',
    data: params,
  });
}

export function createClaim(params) {
  const { orderId, ...data } = params;
  return request(`/orders/claim/${orderId}`, {
    method: 'POST',
    data: data,
  });
}

export function importOrders(params) {
  const { ...rest } = params;
  return request(`/orders/import`, {
    method: 'POST',
    data: rest,
  });
}

export function uploadOrdersFromFile(params) {
  const { file } = params;
  const formData = new FormData();
  formData.append('file', file);
  return request(`/orders/upload`, {
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function updateOrder(params) {
  const { id, ...rest } = params;
  return request(`/orders/${id}`, {
    method: 'PATCH',
    data: rest,
  });
}

export function cancelOrder(params) {
  const { orderId } = params;
  return request(`/orders/cancel/${orderId}`, {
    method: 'PATCH',
  });
}

export function retryOrderAddress(params) {
  const { orderId, ...rest } = params;
  return request(`/orders/retry-address/${orderId}`, {
    method: 'PATCH',
    data: rest,
  });
}

export function retryOrder(params) {
  const { orderId } = params;
  return request(`/orders/retry/${orderId}`, {
    method: 'PATCH',
  });
}

export function updateOrdersBatch(params) {
  const { update } = params;
  return request(`/orders/batch`, {
    method: 'PATCH',
    data: update,
  });
}

export function deleteOrder(params) {
  const { id } = params;
  return request(`/orders/${id}`, {
    method: 'DELETE',
  });
}

export function deleteOrders(params) {
  const { ...rest } = params;
  return request(`/orders/remove-orders`, {
    method: 'POST',
    data: rest,
  });
}

export function getLabel(params) {
  const { id } = params;
  const url = `/orders/label/${id}`;
  return request(url, {
    method: 'GET',
  });
}

export function getLabels(params) {
  const { orderIds } = params;
  const query = `?${orderIds.map((oid) => `orderIds=${oid}`).join('&')}`;
  return request(`/orders/labels${query}`, {
    method: 'GET',
  });
}

export function getInactiveOrders(params) {
  return request(`/orders/inactive`, {
    method: 'GET',
    params,
  });
}

export function getIncorrectlyFailedOrders() {
  return request(`/dashboard/incorrect-delivery-failed`, {
    method: 'GET',
  });
}

export function confirmInactiveOrder(params) {
  const { orderId, action } = params;
  return request(`/orders/confirm-inactive/${orderId}`, {
    method: 'POST',
    data: { action },
  });
}

export function performOrderAction(params) {
  const { orderId, action, extraInput } = params;
  return request(`/orders/order-action/${orderId}`, {
    method: 'POST',
    data: { action, ...extraInput },
  });
}
